"use client";

import React from "react";
import { ArrowRight, Info } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
const silhouettes = [{
  id: "m1",
  name: "The Essential 40mm",
  category: "Minimalist",
  price: "$125",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_minimalist_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_minimalist_side.png"
}, {
  id: "c1",
  name: "Apex Chrono",
  category: "Chronograph",
  price: "$185",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_chrono_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_chrono_back.png"
}, {
  id: "d1",
  name: "Deep Sea 200m",
  category: "Diver",
  price: "$160",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_diver_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_diver_lume.png"
}, {
  id: "m2",
  name: "Slimline 38",
  category: "Minimalist",
  price: "$115",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_minimalist_2_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_minimalist_2_side.png"
}, {
  id: "c2",
  name: "Rally Timer",
  category: "Chronograph",
  price: "$195",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_chrono_2_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_chrono_2_back.png"
}, {
  id: "d2",
  name: "Pro Diver GMT",
  category: "Diver",
  price: "$210",
  moq: "50",
  imagePrimary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_diver_2_front.png",
  imageSecondary: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_diver_2_side.png"
}];
const categories = ["All", "Minimalist", "Chronograph", "Diver"];
export default function BrowseOurSilhouettes() {
  return <section id="browse-our-silhouettes" className="bg-background py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">Choose a Watch Model to Start Your Brand</h2>
          <p className="mt-4 max-w-[700px] text-lg text-secondary">Choose a ready-made watch model, add your logo, and launch from as low as 50pcs — without full custom development.</p>
        </div>

        <Tabs defaultValue="All" className="w-full">
          <div className="mb-12 flex justify-center">
            <TabsList className="h-auto flex-wrap justify-center gap-2 border border-border p-1 shadow-none">
              {categories.map((category, index) => <TabsTrigger key={category} value={category} data-index={index} className="px-6 py-2.5 text-sm sm:text-base text-secondary data-[state=active]:bg-primary data-[state=active]:text-primary-foreground hover:text-primary transition-colors shadow-none">
                  {category}
                </TabsTrigger>)}
            </TabsList>
          </div>

          {categories.map((category, tabIndex) => <TabsContent key={category} value={category} data-index={tabIndex} className="mt-0 outline-none focus-visible:ring-0">
              <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {silhouettes.filter(watch => category === "All" || watch.category === category).map((watch, watchIndex) => <Card key={watch.id} data-index={watchIndex} className="group flex h-full flex-col overflow-hidden border-border bg-card transition-all duration-300 hover:border-primary shadow-none">
                      <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/30">
                        <img src={watch.imagePrimary} alt={`${watch.name} primary view`} className="absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ease-in-out group-hover:opacity-0" />
                        <img src={watch.imageSecondary} alt={`${watch.name} secondary view`} className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100" />
                        <div className="absolute top-4 left-4">
                          <span className="inline-flex items-center rounded-full bg-background/90 px-2.5 py-0.5 text-xs font-medium text-foreground backdrop-blur-sm">
                            {watch.category}
                          </span>
                        </div>
                      </div>

                      <CardContent className="flex flex-1 flex-col justify-between p-6">
                        <div>
                          <div className="mb-2 flex items-start justify-between gap-4">
                            <h3 className="text-xl font-semibold tracking-tight text-foreground">
                              {watch.name}
                            </h3>
                            <div className="text-right">
                              
                            </div>
                          </div>

                          
                        </div>

                        <Button asChild variant="default" className="w-full group/btn rounded-lg transition-all duration-300 shadow-none">
                          <Link to="#">
                            Customize Silhouette
                            <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                          </Link>
                        </Button>
                      </CardContent>
                    </Card>)}
              </div>
            </TabsContent>)}
        </Tabs>
      </div>
    </section>;
}